export const NEGATIVE_REVIEW_MAX_LIMIT = 3
